
export const LanguageNames = {
  en: 'English',
  he: 'עברית'
};

export const LanguageDirections = {
  en: 'ltr',
  he: 'rtl'
};



// WEBPACK FOOTER //
// ./src/lib/languages.js